const PrintExtraBadge = ({ extraBadge }) => {
    const extraBadgeStylingForm = extraBadge?.stylingForm ? JSON.parse(extraBadge.stylingForm) : {};
    const CSSValues = extraBadge?.cssValues ? JSON.parse(extraBadge.cssValues) : {};
    const specialCSSRules = extraBadge?.specialCSSRules ? JSON.parse(extraBadge.specialCSSRules) : {};
    const fieldOrdering = extraBadge?.fieldOrdering
        ? typeof extraBadge.fieldOrdering === "string"
            ? JSON.parse(extraBadge.fieldOrdering).extraBadgeOrderingFields || []
            : extraBadge.fieldOrdering.extraBadgeOrderingFields || []
        : [];

    const toLowerCamelCase = (str) => str.charAt(0).toLowerCase() + str.slice(1);

    const determineTextStyle = (cssFieldName, fieldValue) => {
        const defaultStyle = { fontSize: "24px", fontFamily: "Nunito Sans", margin: "0 0 5px 0", padding: "0" };
        const specialCssSmaller = specialCSSRules?.[`${cssFieldName}Smaller`];
        const specialCssSmallest = specialCSSRules?.[`${cssFieldName}Smallest`];

        if (!fieldValue) return defaultStyle;
        if (specialCssSmallest?.active && fieldValue.length > specialCssSmallest.length) return CSSValues[`${cssFieldName}Smallest`] || defaultStyle;
        if (specialCssSmaller?.active && fieldValue.length > specialCssSmaller.length) return CSSValues[`${cssFieldName}Smaller`] || defaultStyle;
        return CSSValues[cssFieldName] || defaultStyle;
    };

    const renderTextField = (cssFieldName) => {
        const lowerCamelCaseString = toLowerCamelCase(cssFieldName);
        const fieldValue = extraBadgeStylingForm?.[cssFieldName] || extraBadgeStylingForm?.[lowerCamelCaseString] || "";

        if (!CSSValues[cssFieldName] && cssFieldName !== "ScannerField") return null;

        const style = determineTextStyle(cssFieldName, fieldValue);
        return <p key={cssFieldName} style={style}>{fieldValue}</p>;
    };

    const renderImageField = (cssFieldName) => {
        const imageCSS = CSSValues[cssFieldName] || {
            width: "20px",
            height: "20px",
            marginTop: "10px",
            padding: "0",
            position: "relative",
            left: "150px"
        };
        const imageFile = extraBadgeStylingForm?.[cssFieldName];

        return imageFile ? <img key={cssFieldName} style={imageCSS} src={imageFile} alt={cssFieldName} /> : null;
    };

    return (
        <>
            {fieldOrdering.map((field, index) => {
                if (/scannerfield|image/i.test(field.cssFieldName)) {
                    return renderImageField(field.cssFieldName);
                }
                return renderTextField(field.cssFieldName);
            })}
        </>
    );
};

export default PrintExtraBadge;
